package flagpack.icons.large

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Papua New Guinea Flag (32x24dp)
 *
 * - ISO Alpha-2: PG
 * - ISO Alpha-3: PNG
 * - ISO Numeric: 598
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Large.PapuaNewGuinea: ImageVector by lazy {
    ImageVector.Builder(
        name = "Papua New Guinea:PG:PNG:598:Large",
        defaultWidth = 32.dp,
        defaultHeight = 24.dp,
        viewportWidth = 32f,
        viewportHeight = 24f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
            path(fill = SolidColor(Color(0xFFE11C1B))) {
                moveTo(2f, 0f)
                lineTo(30f, 0f)
                arcTo(2f, 2f, 0f, isMoreThanHalf = false, isPositiveArc = true, 32f, 2f)
                lineTo(32f, 22f)
                arcTo(2f, 2f, 0f, isMoreThanHalf = false, isPositiveArc = true, 30f, 24f)
                lineTo(2f, 24f)
                arcTo(2f, 2f, 0f, isMoreThanHalf = false, isPositiveArc = true, 0f, 22f)
                lineTo(0f, 2f)
                arcTo(2f, 2f, 0f, isMoreThanHalf = false, isPositiveArc = true, 2f, 0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF1D1D1D)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                lineTo(32f, 24f)
                horizontalLineTo(0f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFEEEEF6)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(7.083f, 18.268f)
                horizontalLineTo(8.415f)
                lineTo(9.049f, 16.775f)
                lineTo(9.793f, 18.258f)
                lineTo(11.158f, 18.333f)
                lineTo(9.991f, 19.602f)
                lineTo(10.59f, 21.131f)
                lineTo(9.108f, 20.28f)
                lineTo(7.739f, 21.139f)
                lineTo(8.255f, 19.654f)
                lineTo(7.083f, 18.268f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFEEEEF6)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(3.083f, 14.269f)
                horizontalLineTo(4.415f)
                lineTo(5.049f, 12.775f)
                lineTo(5.793f, 14.258f)
                lineTo(7.158f, 14.333f)
                lineTo(5.991f, 15.602f)
                lineTo(6.59f, 17.131f)
                lineTo(5.108f, 16.28f)
                lineTo(3.739f, 17.139f)
                lineTo(4.255f, 15.654f)
                lineTo(3.083f, 14.269f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFEEEEF6)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(7.083f, 12.269f)
                horizontalLineTo(8.415f)
                lineTo(9.049f, 10.775f)
                lineTo(9.793f, 12.258f)
                lineTo(11.158f, 12.333f)
                lineTo(9.991f, 13.602f)
                lineTo(10.59f, 15.131f)
                lineTo(9.108f, 14.28f)
                lineTo(7.739f, 15.139f)
                lineTo(8.255f, 13.654f)
                lineTo(7.083f, 12.269f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFEEEEF6)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(9.711f, 16.564f)
                lineTo(10.627f, 16.534f)
                lineTo(10.957f, 15.59f)
                lineTo(11.328f, 16.529f)
                lineTo(12.17f, 16.61f)
                lineTo(11.412f, 17.146f)
                lineTo(12.024f, 18.096f)
                lineTo(10.962f, 17.699f)
                lineTo(10.042f, 18.109f)
                lineTo(10.528f, 17.172f)
                lineTo(9.711f, 16.564f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFEEEEF6)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(11.711f, 14.564f)
                lineTo(12.627f, 14.534f)
                lineTo(12.957f, 13.59f)
                lineTo(13.328f, 14.529f)
                lineTo(14.17f, 14.61f)
                lineTo(13.412f, 15.146f)
                lineTo(14.024f, 16.096f)
                lineTo(12.962f, 15.699f)
                lineTo(12.042f, 16.109f)
                lineTo(12.528f, 15.172f)
                lineTo(11.711f, 14.564f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFBCD17)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(21.084f, 2f)
                curveTo(21.084f, 2f, 17.995f, 2.616f, 18.862f, 6.91f)
                horizontalLineTo(18.421f)
                curveTo(18.421f, 6.91f, 18.457f, 6.686f, 18.034f, 6.554f)
                curveTo(17.61f, 6.423f, 17.695f, 6.472f, 17.476f, 6.554f)
                curveTo(17.258f, 6.636f, 15.927f, 6.554f, 15.927f, 6.554f)
                verticalLineTo(6.719f)
                lineTo(16.869f, 7.125f)
                curveTo(16.869f, 7.125f, 16.846f, 7.464f, 17.239f, 7.651f)
                curveTo(17.633f, 7.839f, 17.918f, 7.929f, 17.918f, 7.929f)
                curveTo(17.918f, 7.929f, 17.977f, 8.303f, 17.608f, 8.303f)
                curveTo(17.239f, 8.303f, 15.756f, 7.822f, 15.229f, 9.003f)
                curveTo(14.701f, 10.184f, 14f, 11.051f, 14f, 11.051f)
                horizontalLineTo(14.791f)
                lineTo(14.579f, 11.315f)
                horizontalLineTo(15.469f)
                lineTo(15.229f, 11.451f)
                curveTo(15.229f, 11.451f, 16.33f, 11.439f, 16.416f, 11.315f)
                curveTo(16.502f, 11.19f, 16.416f, 11.652f, 16.416f, 11.652f)
                curveTo(16.416f, 11.652f, 17.483f, 11.165f, 17.542f, 11.051f)
                lineTo(18.04f, 11.393f)
                lineTo(18.182f, 10.814f)
                lineTo(18.716f, 11.051f)
                lineTo(18.862f, 10.5f)
                curveTo(18.862f, 10.5f, 20.374f, 13.029f, 21.521f, 12.884f)
                verticalLineTo(12.464f)
                lineTo(22.567f, 12.884f)
                lineTo(22.7f, 12.697f)
                curveTo(22.7f, 12.697f, 23.965f, 13.212f, 24.354f, 13.26f)
                lineTo(24.076f, 12.697f)
                horizontalLineTo(24.354f)
                lineTo(24.076f, 11.652f)
                horizontalLineTo(24.354f)
                lineTo(23.799f, 10.814f)
                lineTo(23.954f, 10.588f)
                lineTo(23.851f, 10.29f)
                curveTo(23.851f, 10.29f, 25.887f, 10.938f, 25.795f, 11.97f)
                curveTo(25.703f, 13.001f, 24.796f, 13.418f, 24.796f, 13.418f)
                curveTo(24.796f, 13.418f, 23.927f, 13.684f, 23.142f, 13.627f)
                curveTo(23.142f, 13.627f, 23.765f, 14.363f, 25.084f, 14.113f)
                curveTo(26.403f, 13.864f, 26.84f, 12.585f, 26.84f, 12.585f)
                curveTo(26.84f, 12.585f, 27.445f, 13.841f, 26.947f, 14.502f)
                curveTo(26.449f, 15.162f, 24.233f, 15.626f, 24.233f, 15.626f)
                curveTo(24.233f, 15.626f, 25.035f, 16.096f, 25.795f, 15.975f)
                curveTo(26.555f, 15.855f, 27.738f, 15.193f, 27.967f, 14.113f)
                curveTo(28.196f, 13.034f, 27.176f, 11.041f, 26.714f, 10.814f)
                lineTo(26.531f, 10.123f)
                lineTo(26.947f, 10.29f)
                lineTo(26.094f, 8.205f)
                lineTo(26.508f, 8.296f)
                lineTo(25.302f, 6.796f)
                lineTo(25.634f, 6.693f)
                lineTo(23.968f, 5.496f)
                lineTo(24.466f, 5.364f)
                curveTo(24.466f, 5.364f, 23.235f, 4.74f, 21.83f, 5.496f)
                lineTo(21.843f, 5.235f)
                lineTo(21.474f, 5.297f)
                lineTo(21.496f, 5.01f)
                lineTo(21.863f, 4.454f)
                lineTo(21.312f, 4.242f)
                curveTo(21.312f, 4.242f, 21.757f, 3.573f, 21.691f, 3.582f)
                curveTo(21.691f, 3.582f, 21.194f, 3.724f, 21.222f, 3.665f)
                curveTo(21.222f, 3.665f, 21.473f, 3.02f, 21.407f, 3.037f)
                curveTo(21.407f, 3.037f, 20.831f, 3.233f, 20.917f, 3.135f)
                lineTo(21.138f, 2.741f)
                lineTo(21.084f, 2f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun PapuaNewGuineaPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Large.PapuaNewGuinea,
            contentDescription = "Papua New Guinea Flag"
        )
    }
}
